import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import logo from "../assets/logo_officiel.png"

const styles = StyleSheet.create({
    page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5, flexDirection: 'column' },
    titleContainer: { alignItems: 'center' },
    qrContainer: { alignItems: 'center', flexDirection: 'column', marginTop: 24 },
    qrImage: {
        width: "30%",
        height: "40%"
    },
    logo: { width: 120 },
    logo_chu: { width: 80,borderRadius:'50px' },
    infoContainer: { flexDirection: 'row', marginTop: 24 },
    spaceBetween: { flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', color: "#3E3E3E" },
    reportTitle: { fontSize: 16, textAlign: 'center' },
    addressTitle: { fontSize: 14, fontStyle: 'bold' },
    invoice: { fontWeight: 'bold', fontSize: 20 },
    invoiceNumber: { fontSize: 11, fontWeight: 'bold' },
    address: { fontWeight: 400, fontSize: 10 },
});
function TicketComponent({ data }) {
    const dataUrl = document.getElementById(data.reference).toDataURL();
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.titleContainer}>
                    <Image style={styles.logo} src={logo} />
                </View>
                <View style={styles.infoContainer}>
                    <View style={styles.spaceBetween}>
                        <View>
                            <Image style={styles.logo_chu} src={data.logo}  />
                            <Text style={styles.invoice}>{data.chu.toUpperCase()}</Text>
                        </View>
                        <View>
                            <Text style={styles.addressTitle}>{data.service.toUpperCase()} </Text>
                            <Text style={styles.addressTitle}>{data.contact_chu}</Text>
                            <Text style={styles.addressTitle}>{data.email_chu}</Text>
                        </View>
                    </View>
                </View>

                <View style={styles.qrContainer}>
                    <Image style={styles.qrImage} src={dataUrl} />
                </View>
            </Page>
        </Document>
    )
}

export default TicketComponent